<template>
    <div class="container-fluid gdwrapper col-l-12 col-m-12 col-12">
        <label class="col-l-3 col-m-4 col-5" :for="props.dataField" >{{ props.dataField }}</label>
        <input :id="props.dataField" class="col-l-9 col-m-8 col-7" :aria-placeholder="placeHolder" :placeholder="placeHolder" :value="modelValue" @input="updateValue" />
    </div>
</template>

<script setup>
  import {defineEmits, defineModel, defineProps} from 'vue'
  const props = defineProps({
    dataField: String,
    placeHolder: String
  });
  const emits = defineEmits(['update:modelValue']); 
  const modelValue = defineModel();
  function updateValue(event) {
      emits('update:modelValue', event.target.value);
  }
</script>

<style lang="css" scoped>
  .finput {
    grid-area: npt;
  }
  .flabel {
    grid-area: lbl;
  }
  .finput-wrapper {
    display:grid;
    grid-template:
      "lbl npt" 5vh / 2fr 3fr;
  }
</style>